<script>
export default {
  name: "ContentFooter"
};
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/settings.styl"
@import "~@/assets/styles/helpers.styl"
@import "ContentFooter"
</style>
